const useSettingCarousel = (component: any): Object => {

  const setting = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 0.7,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,

          dots: true,
        },
      },
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 1.09,
          slidesToScroll: 1,
          infinite: false,

          dots: true,
        },
      },
      {
        breakpoint: 440,
        settings: {
          slidesToShow: 1.09,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          appendDots: (dots) => component(dots),
        },
      },
    ],
  };
  return setting;
}
export default useSettingCarousel;